import React from 'react';
import { myTheme } from '../assets/styles/my-theme';
import { Icon, mergeStyleSets, TooltipHost } from '@fluentui/react';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});


export interface TableIconInoltroProps {
}

const TableIconInoltro: React.FunctionComponent<TableIconInoltroProps> = (props) => {
    return (
        <div className={classNames.iconField} >
            <TooltipHost content="Inoltro" id={"tooltipInoltro"}>
                <Icon iconName="FastForward" style={{ fontSize: 16, color: palette.themePrimary }} />
            </TooltipHost>
        </div>
    );
}
export default TableIconInoltro;